import LegalPage from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" eyebrow="Your privacy" effectiveDate="February 6, 2026">
      <p>
        My Daily Prayer ("the app", "we", "us") is a personal prayer journal.
        We take your trust seriously and collect only what's needed to make
        the journal work for you.
      </p>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>What we collect</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li><b>Account info</b>: your email address, display name, and profile picture (if you sign in with Google).</li>
        <li><b>Prayer content</b>: the titles, details, "for whom" fields, categories, prayed-for dates, and answered-prayer dates that you create.</li>
        <li><b>Session info</b>: a secure HttpOnly cookie so you stay signed in across visits.</li>
        <li><b>Contact form submissions</b>: only if you write to us via the Contact page (name, email, and message text).</li>
      </ul>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>How we use it</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>To display your prayers to you, and only you, inside your account.</li>
        <li>To send you passwordless sign-in emails when you request one.</li>
        <li>To respond to messages you send us via the Contact page.</li>
      </ul>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>What we do NOT do</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>We do <b>not</b> sell your data.</li>
        <li>We do <b>not</b> show your prayers to other users. Prayers are private and yours alone.</li>
        <li>We do <b>not</b> use your prayer content to train AI models.</li>
        <li>We do <b>not</b> serve third-party ads or ad-tracking cookies.</li>
      </ul>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Service providers</h2>
      <p>
        We use a small number of trusted providers to keep the app running:
      </p>
      <ul className="list-disc pl-5 space-y-2">
        <li><b>Google</b> — for optional Sign-In. Google only shares your email, name, and profile picture with us.</li>
        <li><b>Resend</b> — for sending sign-in and contact emails.</li>
        <li><b>MongoDB Atlas</b> — for storing your account and prayers.</li>
        <li><b>Emergent</b> — for hosting the app.</li>
      </ul>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Your rights</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li><b>Access</b>: you can see everything we store about you inside the app.</li>
        <li><b>Delete</b>: at any time, you can delete your account from the user menu. This permanently removes your account, all prayers, all sign-in sessions, and any pending sign-in tokens.</li>
        <li><b>Export</b>: contact us to request a copy of your data.</li>
      </ul>

      <h2 className="text-xl text-[#2C2A2E] pt-4" style={{ fontFamily: "'Playfair Display', serif" }}>Contact</h2>
      <p>
        Questions or requests? Email us at{" "}
        <a className="text-[#9B8BAF] underline underline-offset-4" href="mailto:hello@my-daily-prayer.org">hello@my-daily-prayer.org</a>{" "}
        or use the Contact page.
      </p>
    </LegalPage>
  );
}
